import { computed, ref, watch } from 'vue'

const theme = ref<'light' | 'dark'>(
  (localStorage.getItem('theme') as 'light' | 'dark') || 'light'
)

const applyTheme = (t: 'light' | 'dark') => {
  document.documentElement.setAttribute('data-theme', t)
  localStorage.setItem('theme', t)
}

// Aplicar imediatamente na carga do módulo
applyTheme(theme.value)

// Watch no module-level — reage a mudanças de qualquer componente
watch(theme, (newTheme) => {
  applyTheme(newTheme)
})

const isDark = computed(() => theme.value === 'dark')

export function useTheme() {
  const toggleTheme = () => {
    theme.value = theme.value === 'light' ? 'dark' : 'light'
  }

  return {
    theme,
    isDark,
    toggleTheme,
  }
}
